(function () {
  'use strict';

  /*
   * ============================================================
   * GM WATCHES — HEADER JAVASCRIPT
   * ============================================================
   * يعمل بجانب Dawn بدون استبدال وظائف Shopify الأصلية.
   * ============================================================
   */

  const GMHeader = {
    initialized: false,

    init() {
      if (this.initialized) return;

      const header = document.querySelector('.section-header');

      if (!header) return;

      this.header = header;
      this.initialized = true;

      this.setupMobileHeader();
      this.setupCartFeedback();
      this.setupHeaderLinks();
      this.setupOutsideClick();
      this.setupResize();
    },

    /*
     * ------------------------------------------------------------
     * MOBILE HEADER
     * ------------------------------------------------------------
     */

    setupMobileHeader() {
      const drawer = this.header.querySelector('header-drawer');

      if (!drawer) return;

      const summary = drawer.querySelector('summary');

      if (!summary) return;

      summary.setAttribute('aria-label', 'فتح القائمة');

      summary.addEventListener('click', () => {
        setTimeout(() => {
          const menu = drawer.querySelector('.menu-drawer');

          if (!menu) return;

          const isOpen =
            drawer.hasAttribute('open') ||
            menu.classList.contains('menu-opening');

          document.documentElement.classList.toggle(
            'gm-menu-open',
            isOpen
          );

          document.body.classList.toggle(
            'gm-menu-open',
            isOpen
          );
        }, 20);
      });
    },

    /*
     * ------------------------------------------------------------
     * CART FEEDBACK
     * ------------------------------------------------------------
     */

    setupCartFeedback() {
      const cart = this.header.querySelector('#cart-icon-bubble');

      if (!cart) return;

      cart.addEventListener('click', () => {
        cart.classList.add('gm-cart-click');

        setTimeout(() => {
          cart.classList.remove('gm-cart-click');
        }, 220);
      });
    },

    /*
     * ------------------------------------------------------------
     * HEADER LINKS
     * ------------------------------------------------------------
     */

    setupHeaderLinks() {
      const links = this.header.querySelectorAll(
        '.header__icon'
      );

      links.forEach((link) => {
        link.addEventListener('touchstart', () => {
          link.classList.add('gm-touch');

          setTimeout(() => {
            link.classList.remove('gm-touch');
          }, 180);
        }, { passive: true });
      });
    },

    /*
     * ------------------------------------------------------------
     * OUTSIDE CLICK
     * ------------------------------------------------------------
     */

    setupOutsideClick() {
      document.addEventListener('click', (event) => {
        const drawer = this.header.querySelector('header-drawer');

        if (!drawer) return;

        if (!drawer.contains(event.target)) {
          document.documentElement.classList.remove(
            'gm-menu-open'
          );

          document.body.classList.remove(
            'gm-menu-open'
          );
        }
      });
    },

    /*
     * ------------------------------------------------------------
     * RESIZE
     * ------------------------------------------------------------
     */

    setupResize() {
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 990) {
          document.documentElement.classList.remove(
            'gm-menu-open'
          );

          document.body.classList.remove(
            'gm-menu-open'
          );
        }
      });
    }
  };

  /*
   * ------------------------------------------------------------
   * START
   * ------------------------------------------------------------
   */

  function startGMHeader() {
    GMHeader.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startGMHeader
    );
  } else {
    startGMHeader();
  }

  /*
   * Shopify Theme Editor support
   */

  document.addEventListener(
    'shopify:section:load',
    function () {
      GMHeader.initialized = false;
      startGMHeader();
    }
  );

  /*
   * Public access
   */

  window.GMHeader = GMHeader;

})();